<template>
    <div class="review">
        <b-card body-class="p-3" :title="$translate('bulk_reviews')">
            <div class="mt-3">
                <b-row>
                    <b-col cols="12" md="6" class="d-flex align-items-center">
                        <b-button id="filter-btn" class="ms-0" variant="blue-button" @click="shouldShowFilters = !shouldShowFilters">
                            <span style="white-space: nowrap">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                    }`"></b-icon>
                            </span>
                        </b-button>
                        <div class="col-lg-1 col-md-1 col-sm-3 ms-2">
                            <b-button id="reset-filter-btn" type="button" v-b-tooltip.hover @click="resetFilters"
                                :title="$translate('reset_filters')" variant="blue-button">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="d-flex justify-content-end align-items-center">
                        <b-button id="do-bulk-action-btn" :disabled="selectedOrders.length == 0" variant="info" class="btn-fw" block
                            @click="doBulkAction">{{ $translate('submit') }}</b-button>
                    </b-col>
                </b-row>
            </div>
            <b-card-body class="p-0 mt-3">
                <Filters v-if="shouldShowFilters" :model="reviewFilter" @getReviewTypeId="setReviewTypeId"
                    :filteredTypes="filteredTypes" :status="status" :officers="officers" :activityStatus="activityStatus" />

                <b-table id="orderTable" :fields="fields" :busy="loading" :items="orders" selectable responsive
                    @row-selected="onRowSelected" ref="orderTable">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
                    <template #head(id)>
                        <b-form-checkbox v-if="orders.length > 0"
                            :checked="(!!orders && !!selectedOrders) && orders.length === selectedOrders.length"
                            @change="toggleAllRow()"></b-form-checkbox>
                    </template>

                    <template #cell(id)="{ rowSelected, index }">
                        <b-form-checkbox :checked="rowSelected" @change="toggleRow(index, rowSelected)"></b-form-checkbox>
                    </template>
                    <template #cell(custom)="{ item }">
                        <b-button :id="'view-review-btn-'+item.id" v-if="hasPermissionView" :to="`/ams/activities/${item.id}`" class="mr-2 test-view-review-btn"
                            variant="pink-button" target="_blank">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>

                    <template #cell(return_quantity)="row">
                        <b-form-input type="number" v-model="row.item.return_quantity"
                            placeholder="Return Qty"></b-form-input>
                    </template>
                </b-table>
                <b-col>
                    <b-pagination class="float-right mt-4" v-model="pagination.page" :total-rows="pagination.total"
                        :per-page="pagination.pageSize" :next-text="$translate('next')" :prev-text="$translate('previous')"
                        aria-controls="orderTable" pills align="center"></b-pagination>
                </b-col>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import Filters from './Filters.vue'
import moment from 'moment';
const defaultFilters = Object.freeze({
    from: moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'),
    to: moment().add(1, 'weeks').endOf('week').format('YYYY-MM-DD'),
    status: '',
    activity_status: '',
    review_officer: '',
    activity_officer: '',
    type: '',
})
export default {
    name: 'reviews',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        shouldShowFilters: false,
        selectedOrders: [],
        checkoff_type_id: null,
        loading: false,
        reviewFilter: { ...defaultFilters },
    }),
    components: { Filters },
    computed: {
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        pagination() {
            console.log("this.$store.state.orders.pagination", this.$store.state.orders.pagination)
            return this.$store.state.orders.pagination || {}
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        status() {
            return [
                { id: 1, label: this.$translate('completed') },
                { id: 0, label: this.$translate('not_completed') },
            ]
        },
        activityStatus() {
            return [
                { id: 3, label: this.$translate('pending') },
                { id: 1, label: this.$translate('completed') },
                { id: 2, label: this.$translate('processing') },
            ]
        },
        selectedReviewTypeName() {
            const selectedType = this.filteredTypes.find(type => type.id === this.checkoff_type_id);
            return selectedType ? selectedType.name : null;
        },
        fields() {
            return [
                { key: 'id', label: '' },
                { key: 'custom', label: this.$translate('actions') },
                {
                    key: 'review_type',
                    label: this.$translate('review_type'),
                    formatter: (value, key, item) => this.reviewData(item) && this.reviewData(item).checkoff_type && this.reviewData(item).checkoff_type.name
                },
                { key: 'reference_no', label: this.$translate('reference_no') },
                {
                    key: 'review_status',
                    label: this.$translate('review_status'),
                    formatter: (value, key, item) => this.reviewData(item) && this.reviewData(item).completed === 1 ? this.$translate('completed') : this.$translate('not_completed')
                },
                {
                    key: 'description', label: this.$translate('description'),
                    formatter: x => `${(x) || '-'}`,
                    tdClass: 'text-left',
                    thClass: 'text-center',
                },
                {
                    key: 'customer',
                    label: this.$translate('customer'),
                    formatter: x => `${(x && x.name) || '-'}`,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    key: 'type',
                    label: this.$translate('activity_type'),
                    formatter: x => x.name,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    key: 'driver',
                    label: this.$translate('activity_officer'),
                    formatter: x => `${(x && x.first_name) || '-'} ${(x && x.last_name) || ''}`,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    key: 'checkoff_type_id',
                    label: this.$translate('review_officer'),
                    formatter: (value, key, item) => this.reviewData(item) && this.reviewData(item).officer_name,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    key: 'activity_status',
                    label: this.$translate('activity_status'),
                    formatter: (value, key, item) => (this.checkActivityStatus(item)),
                },
              
                {
                    key: 'comments',
                    label: this.$translate('comments'),
                    formatter: (value, key, item) => this.reviewData(item) && this.reviewData(item).comments ? this.reviewData(item).comments : '-',
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    key: 'completed_at',
                    label: this.$translate('completed_on'),
                    formatter: (value, key, item) => this.reviewData(item) && this.reviewData(item).completed_at ? moment((this.reviewData(item).completed_at), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD, h:mm:ss a') : '-',
                    tdClass: 'text-center',
                    thClass: 'text-center',
                }
            ]
        },
        user() {
            const user = this.$store.state.user
            console.log('user', user)
            return user
        },
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        filteredTypes() {
            const _types = []
            console.log('user.roles', this.user.roles)
            const reviewType = this.checkoffTypes
            for (let type of reviewType) {
                if (type.checkoff_type_roles && type.checkoff_type_roles) {
                    for (let type_role of type.checkoff_type_roles) {
                        if (
                            this.user.roles.some(
                                user_role => user_role.role_id === type_role.role_id
                            )
                        ) {
                            _types.push(type)
                        }
                    }
                }
            }
            console.log(_types, "_types");
            return _types
        },
        orders() {
            return this.$store.state.orders.items
        },
       /* relevantOrders() {
            return this.orders
            const { checkoff_type_id } = this
            return this.orders.filter(x => {
                if (!x.checkoff_template_id) return false
                const checkoffs = x.checkoffs || []
                const _selectedCheckoff = checkoffs.find(
                    x => x.checkoff_type_id == checkoff_type_id
                )
                console.log('_selectedCheckoff', _selectedCheckoff)
                if (checkoffs.length === 0) return false
                if (!_selectedCheckoff) return false
                if (_selectedCheckoff.sequence_no == 1) return true
                if (checkoffs.length === 1) return true
                return !checkoffs.some(
                    x => {
                        console.log(x.id, selectedCheckoff.id, x.completed, x.sequence_no < selectedCheckoff.sequence_no, "sequence_no");
                        return (x.id != _selectedCheckoff.id &&
                            x.sequence_no < _selectedCheckoff.sequence_no)
                    }
                )
            })
        },*/

    },
    watch: {

        orders: {
            immediate: false,
            handler: function () {
                this.loading = false
            }
        },
        'pagination.page': function (newPage) {
            if (this.page != newPage) {
                this.loading = true
                this.changePage(newPage)
            }
            this.page = newPage
        },
        reviewFilter: {
            immediate:true,
            handler: function () {
                this.loading = true
                this.fetchOrders()
            },
            deep: true
        }
    },
    async created() {
        await this.$store.dispatch('checkoffTypes/fetchAll')
        await this.$store.dispatch('users/fetchAll')
    },
    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.fetchOrders()
        },
        setReviewTypeId(val) {
            this.checkoff_type_id = val
        },
        resetFilters() {
            this.reviewFilter = { ...defaultFilters }
        },
        checkActivityStatus(item) {
            console.log(item, "checkActivityStatus");
            return item.completed == 0 ? item.released == 1 ?
                this.$translate('processing') : this.$translate('pending') : this.$translate('completed')
        },
        reviewData(item) {
            const _selectedCheckoff = item.checkoffs.find(
                x => x.checkoff_type_id == this.reviewFilter.type
            )
            console.log("itemss", _selectedCheckoff)
            return _selectedCheckoff
        },
        onRowSelected(items) {
            this.selectedOrders = items
        },
        selectAllRows() {
            this.$refs.orderTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.orderTable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.orderTable.unselectRow(index)
            else this.$refs.orderTable.selectRow(index)
        },

        toggleAllRow() {
            if (this.filteredActivity.length === this.selectedOrders.length)
                this.$refs.orderTable.clearSelected()
            else this.$refs.orderTable.selectAllRows()
        },
        ///////////////////////////////
        async fetchOrders() {
            try {
                const {
                    reviewFilter,
                    pagination: { page = 1 },
                } = this
                await this.$store.dispatch('orders/selectCheckoffOrders', {
                    reviewFilter,
                    page,
                })
            } catch (error) {
                console.log(error);
            }

        },

        async doBulkAction() {
            try {
                console.log('selectedOrders', this.selectedOrders)
                const title = this.$translate('clear_action')
                const message = this.$translate(`clear_action_note`)
                const result = await this.confirmMessage(title, message)
                if (!result) throw new Error()

                const orders = this.selectedOrders.map(x => x.id)
                const  checkoff_type_id  = this.reviewFilter.type
                console.log('orders--checkoff_type_id', checkoff_type_id)
                console.log('orders--tests', orders)
                await this.$store.dispatch('orders/bulkCheckoffOrders', {
                    orders,
                    checkoff_type_id,
                })
                this.doToast(
                    this.$translate('success'),
                    this.$translate('selected_order_clear'),
                    'success'
                )
                this.clearSelected()
                this.fetchOrders()
            } catch (error) {
                this.doToast(
                    this.$translate('error'),
                    error.message,
                    'danger'
                )
            }
        },
    },
}
</script>
